module.exports = __webpack_public_path__ + "img/bg_1.2f876e8e.jpg";